import { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { APIClient } from '../../../helpers/api_helper';
import { createData } from '../../../utils/createData';
import {
  Plans,
  Kinship,
  Offices,
  CategoryPlans,
  Organizations,
} from '../../../store/actions';

export const useValidationOfProposals = () => {
  const [maxDependents, setMaxDependents] = useState(0);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [paymentConditionsOptions, setPaymentConditionsOptions] = useState([]);

  const api = new APIClient();
  const dispatch = useDispatch();

  const { categoryPlans, plans, kinships, organizations, offices } =
    useSelector((state) => ({
      plans: state.Plans.plans,
      offices: state.Offices.offices,
      kinships: state.Kinship.kinships,
      categoryPlans: state.CategoryPlans.categoryPlans,
      organizations: state.Organizations.organizations,
    }));

  const situationOptions = useMemo(
    () => [
      {
        value: '1',
        label: 'Contratado',
      },
      {
        value: '2',
        label: 'Efetivo',
      },
      {
        value: '3',
        label: 'Aposentado',
      },
      {
        value: '4',
        label: 'Cancelado',
      },
      {
        value: '5',
        label: 'Inativo',
      },
    ],
    []
  );

  const paymentFrequencyOptions = useMemo(
    () => [
      { value: 'M', label: 'Mensal' },
      { value: 'Y', label: 'Anual' },
    ],
    []
  );

  const requestGetCategoryPlans = useCallback(() => {
    dispatch(CategoryPlans());
  }, [dispatch]);

  const requestGetPlans = useCallback(() => {
    dispatch(Plans());
  }, [dispatch]);

  const requestGetOrganizations = useCallback(() => {
    dispatch(Organizations());
  }, [dispatch]);

  const requestGetKinship = useCallback(() => {
    dispatch(Kinship());
  }, [dispatch]);

  const requestGetOffices = useCallback(() => {
    dispatch(Offices());
  }, [dispatch]);

  const requestGetDepartments = useCallback(async (idOrganization) => {
    await api
      .get(`/register/unit/find-by-organization/${idOrganization}`)
      .then((options) => {
        if (options) {
          let data = [];
          options.map((option) => {
            return data.push({
              label: option.name,
              value: option.id,
            });
          });
          setDepartmentOptions(data);
        }
      });
  }, []);

  const requestGetPaymentConditions = useCallback(async () => {
    await api.get('/register/payment-condition').then((response) => {
      setPaymentConditionsOptions(createData(response));
    });
  }, []);

  const requestGetMaxDependentInPlans = useCallback(async (planId) => {
    const max = await api.get(`/register/plan/${planId}`);

    if (max) {
      setMaxDependents(max.max_dependents);
    }
  }, []);

  return {
    // Methods
    requestGetPlans,
    requestGetKinship,
    requestGetOffices,
    requestGetDepartments,
    requestGetOrganizations,
    requestGetCategoryPlans,
    requestGetPaymentConditions,
    requestGetMaxDependentInPlans,
    // Data
    plans,
    offices,
    kinships,
    maxDependents,
    organizations,
    categoryPlans,
    situationOptions,
    departmentOptions,
    paymentFrequencyOptions,
    paymentConditionsOptions,
  };
};
